(function () {
  var body = document.body;
  var drawer = function () { return document.querySelector('[data-drawer]'); };
  var useDrawer = body.dataset.cartType === 'drawer';

  function openDrawer() {
    var d = drawer(); if (!d) return;
    d.hidden = false; body.classList.add('drawer-open');
    var x = d.querySelector('.drawer__x'); if (x) x.focus();
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.hidden = true; body.classList.remove('drawer-open');
  }
  function refresh() {
    return Promise.all([
      fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch('/cart.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = new DOMParser().parseFromString(res[0]['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-drawer]');
      var d = drawer();
      if (fresh && d) d.innerHTML = fresh.innerHTML;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = res[1].item_count; el.hidden = res[1].item_count === 0;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('a,button'); if (!t) return;
    if (useDrawer && t.matches('[data-cart-link]')) { e.preventDefault(); openDrawer(); return; }
    if (t.matches('[data-drawer-close]')) { closeDrawer(); return; }
    if (t.dataset.line && t.dataset.qty !== undefined) {
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +t.dataset.line, quantity: +t.dataset.qty }) }).then(refresh);
      return;
    }
    if (t.matches('[data-menu-open]')) { toggleMenu(true); return; }
    if (t.matches('[data-menu-close]')) { toggleMenu(false); return; }
    if (t.matches('[data-reviews-more]')) {
      document.querySelectorAll('.review[data-extra]').forEach(function (r) { r.hidden = false; });
      t.parentNode.remove(); return;
    }
    if (t.dataset.seenScroll) {
      var tr = t.closest('.seen').querySelector('[data-seen-track]');
      tr.scrollBy({ left: +t.dataset.seenScroll * tr.clientWidth * 0.8, behavior: 'smooth' }); return;
    }
    if (t.dataset.thumb !== undefined) {
      var g = t.closest('[data-gallery]'), track = g.querySelector('[data-track]');
      track.scrollTo({ left: track.clientWidth * +t.dataset.thumb, behavior: 'smooth' });
    }
  });
  function toggleMenu(open) {
    var p = document.querySelector('[data-menu-panel]'); if (!p) return;
    p.hidden = !open; body.classList.toggle('menu-open', open);
    var b = document.querySelector('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', open);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); toggleMenu(false); } });

  // play muted videos only while visible; respect reduced motion
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vids = document.querySelectorAll('video[data-autoplay], .tile video, .vfeature video');
  if (reduce) {
    vids.forEach(function (v) { v.pause(); v.removeAttribute('autoplay'); v.controls = true; });
  } else if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target; v.muted = true;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  // add to cart without leaving the page
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!useDrawer || !f.matches('form[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    var btn = f.querySelector('[data-add]'); if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(refresh).then(openDrawer)
      .catch(function (err) { alert(err.description || err.message || 'Could not add to cart.'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // thumbnail highlight on scroll
  document.querySelectorAll('[data-track]').forEach(function (track) {
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      track.closest('[data-gallery]').querySelectorAll('[data-thumb]').forEach(function (b) {
        if (+b.dataset.thumb === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }, { passive: true });
  });

  // variant picker
  var root = document.querySelector('[data-product]');
  if (!root) return;
  var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add]');
  var fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: root.dataset.currency });
  var money = function (c) { return fmt.format(c / 100); };

  root.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') return;
    var chosen = Array.prototype.map.call(root.querySelectorAll('fieldset.opt'), function (f) {
      var r = f.querySelector('input:checked'); return r ? r.value : null;
    });
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
    if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    priceEl.innerHTML = v.compare_at_price > v.price
      ? '<s>' + money(v.compare_at_price) + '</s> <span class="sale">' + money(v.price) + '</span>'
      : money(v.price);
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  });
})();

/* size charts: collapse tables in product descriptions into a "Size chart" dropdown */
(function () {
  document.querySelectorAll('.product__info .rte table').forEach(function (t) {
    if (t.closest('details')) return;
    var d = document.createElement('details');
    d.className = 'acc sizechart';
    var s = document.createElement('summary');
    s.textContent = 'Size chart';
    var w = document.createElement('div');
    w.className = 'sizechart__scroll';
    t.parentNode.insertBefore(d, t);
    d.appendChild(s); d.appendChild(w); w.appendChild(t);
  });
})();
